import React from 'react';
import { Alert, Box } from '@mui/material';
import * as ETVConstants from '../ETVConstants';
import ApprovalLibraryItem from './ApprovalLibraryItem';
import ApprovalIcon from '@mui/icons-material/Approval';
import ETVPage from '../tools/ETVPage';

class ApprovalLibrary extends React.Component {
  
    constructor(props) {
      super(props);
      this.onApprove = this.onApprove.bind(this);
    }

    state = {
      loading: false,
      isLoaded: false,
      items: [],
      error: null
    };

    componentDidMount() {
      this.loadData();
    }

    onApprove(contentID, approve) {
      const accessToken = localStorage.getItem('etv.access_token');
      const userId = localStorage.getItem('etv.user_id');
      const url = ETVConstants.getServerBase() + `/content_library?action=content_approval&approve=${approve}&user_id=${userId}&content_id=${contentID}`;
      this.setState({ loading: true, error: null });
      fetch(url, { headers: { user_id: userId, access_token: accessToken } })
        .then(async (res) => {
          if (!res.ok) throw new Error(await res.text());
          try { return await res.json(); } catch { return null; }
        })
        .then(() => this.loadData())
        .catch((error) => this.setState({ error, loading: false, isLoaded: true }));
    }

    loadData = () => {
      const accessToken = localStorage.getItem('etv.access_token');
      const userId = localStorage.getItem('etv.user_id');
      const url = ETVConstants.getServerBase() + `/content_library?action=list_approval_required&user_id=${userId}`;
      this.setState({ loading: true, error: null });
      fetch(url, { headers: { user_id: userId, access_token: accessToken } })
        .then(async (res) => {
          if (!res.ok) throw new Error(await res.text());
          return res.json();
        })
        .then((result) => {
          const list = (result?.list || []).slice().reverse();
          this.setState({ items: list, loading: false, isLoaded: true });
        })
        .catch((error) => this.setState({ error, loading: false, isLoaded: true }));
    };
 
    render() {
      const { loading, items, error } = this.state;

      return (
        <ETVPage width="wide" icon={<ApprovalIcon/>} title={ETVConstants.trans('approvals')} loading={loading}>
          {error ? (
            <Alert severity="error" sx={{mb:2}}>{ETVConstants.trans('error') || 'error'}: {String(error)}</Alert>
          ) : null}

          {items && items.length > 0 ? (
              <Box
                sx={{
                  display: 'grid',
                  gap: 2,
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(auto-fill, minmax(320px, 1fr))',
                  },
                  alignItems: 'start',
                }}
              >
                {items.map((item) => (
                  <Box key={item.content_id} sx={{ minWidth: 0 }}>
                    <ApprovalLibraryItem
                      item={item}
                      user_id={this.props.user_id}
                      onApprove={this.onApprove}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              !loading && <Alert severity="info">{ETVConstants.trans('no_pending_approvals_found')}</Alert>
          )}
        </ETVPage>
      );
    }
}

export default ApprovalLibrary;
